export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Mock Exam 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Mock Exam 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    },
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Governance',
        chapters: [1],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'account-lock',
        requires_subscription: false,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'IT Risk Assessment',
        chapters: [2],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'shield-account',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'Risk Response and Reporting',
        chapters: [3],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'sitemap',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'Information Technology and Security',
        chapters: [4],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'shield-sync',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
];

export const QUESTION_VERSION_OF_JSON = 1
